const extractJinjaVariables = `

You are an AI assistant specialized in analyzing and extracting variables from Jinja2 template fragments. 
Your task is to identify and list all variables used in the given Jinja2 code snippets. Follow these guidelines:

1. Look for variables within {{ }} and {% %} brackets; ignore variables in comment {# #} brackets.
2. If the variable is being assigned a value, return the first value assigned to it.

Ignore any HTML or other non-Jinja code. Focus solely on Jinja2 syntax and elements.

Present your findings in a clear, structured JSON dictionary format. For example:
{
    "var__1": "value_1", // the value is either the first value assigned to variable_1 or null if not assigned
    "var__2": "value_2", // the value is either the first value assigned to variable_1 or null if not assigned
}

### Content:
{content}

JSON Response:

`.trim();

const launchConfigurationTemplate = `
# Assistant configuration
persona: Carol              # name of the persona     
subject: null               # subject id (if applicable)
modality: voice             # "voice" or "text"
variables:
    agent_name: Carol
    pcp_practice_name: Health Clinic
    pcp_last_name: Smith
`.trim();

const simulantLaunchConfigurationTemplate = `
# Simulant launch configuration 

# Simulant configuration
assistant:                      # leave this set to "assistant"
    persona: Carol              # name of the persona     
    variables:
        modality: voice         # "voice" or "text"

# Recipient configuration 
to:
    phone_number: +12223334444  # provide a phone number in +12223334444 format
`.trim();

const validationConfigurationTemplate = `
# Validation configuration
# Parts of this file are used for on-demand & champions validation and external presentation 

# Assistant configuration
persona: Carol              # used for Champions Validation
subject: null               # not used
variables:                  # used for On-Demand and Champions Validation
    modality: voice         # only used for Debugging, "voice" or "text"
`.trim();

const chatUiConfigurationTemplate = `
# Chat UI configuration
# This file is used for the Chat UI interface variables

# The following variables are automatically populated
# by the Chat UI interface and do not need to be provided
# in this file:
#   persona_name - the name of the current persona
#   user_name - the full name of the currently logged on user 
#   user_email - the email address of the currently logged on user
         
# Assistant configuration
assistant:
    persona: Carol              # not used 
    subject: null               # not used
    variables:                  # the variables will be used in the Chat UI interface
        modality: voice         # only used for Debugging, "voice" or "text"
        variable_1: value_1     # specify the Chat UI variables here

# Recipient configuration (human testing)
to:
    phone_number: +12223334444  # only used for Debugging
     
`.trim();

// # Simulation configuration (AI testing)
// # simulants:
//     # names:
//         # - []
//     # include_tags:
//         # - []
//     # exclude_tags:
//         # - []
//     # variables:
//         # first_name:
//             # Bob
// `.trim();

const promptTemplate = `
{# PROMPT_NAME prompt #}
`.trim();

const voicemailTemplate = `
Hi, this is {{ agent_name }} calling from Doctor {{ pcp_last_name }}'s office at {{ pcp_practice_name }}. I'm just checking in. No need to call us back; I'll try again soon.
`.trim();

export {
  extractJinjaVariables,
  launchConfigurationTemplate,
  simulantLaunchConfigurationTemplate,
  validationConfigurationTemplate,
  promptTemplate,
  chatUiConfigurationTemplate,
  voicemailTemplate,
};
